module.exports = __webpack_public_path__ + "static/media/ic_setting.ff2bb88f.svg";